import moment from "moment";

export const formatNumber = (num: number) => {
    return new Intl.NumberFormat('en-IN').format(num);
}

export const formatNumberWithCommas = (number: number | string = 0) => {
    if (String(number) === 'NaN') {
        return 0;
    }
    return String(number).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export const formatNumberWithoutCommas = (number: number | string = 0) => {
    return parseFloat(String(number).replace(/,/g, ''));
};

export const formatDateStringTo2Row = (date: string = '') => {
    const arr = String(date).split(' ');
    return `${arr[0]} <br/> ${arr[1]}`;
}


export const formatQueryParams = (query: any = {}) => {
    const clone = structuredClone(query);
    delete clone.time_request;
    delete clone.time_request_out;
    delete clone.time_request_inner;
    return clone;
}

export const formatLinkHTTPS = (linkString: string = '') => {
    if ((String(linkString).includes('https://') || String(linkString).includes('http://'))) {
        return linkString;
    }
    return `https://${linkString || ''}`;
}
export function isAfter4PMKoreanTime() {
    const currentTime = new Date();
    const currentHour = currentTime.getUTCHours(); // Get the current hour in UTC

    // Convert to Korean time zone (UTC+9)
    const koreanTimeHour = currentHour + 9; // UTC+9

    // Check if it's after 16:00 in Korean time
    if (koreanTimeHour >= 16) {
        return true;
    } else {
        return false;
    }
}

export const renderUrlSearchLookingUpByIP = (ip: string = '') => {
    return `https://whatismyipaddress.com/ip/${ip}`;
}

export const replaceHalfWithStar = (inputString: string, starsCount: number = 8) => {
    var length = inputString.length;
    var halfLength = Math.floor(length / 2);
    var _starsCount = starsCount >= 0 ? starsCount : (length - halfLength);
    var replacedString = inputString.substring(0, halfLength) + '*'.repeat(_starsCount);
    return replacedString;
}

export const formatHour = (hour: number = 0) => {
    if (hour < 0 || hour > 23) {
        return 'Invalid hour';
    }

    let startHour = hour.toString().padStart(2, '0') + ":00";

    let endHour: any = hour + 1;
    if (endHour === 24) {
        endHour = "24:00";
    } else {
        endHour = endHour.toString().padStart(2, '0') + ":00";
    }

    return `${startHour} ~ ${endHour}`;
}

export const renderScriptURLOfInventory = (script_url: string = '', is_wrapper: boolean = false, target_id: string = '', id_inventory: string = '',) => {
    if (!!target_id) {
        return `<div id="${target_id}">
        ${is_wrapper ? `<div id="ahtm-banner-${id_inventory}" style="width: 100%"><script  id="ahtm-script-${id_inventory}" defer src="${script_url}"></script></div>` : `<script id="ahtm-script-${id_inventory}" defer src="${script_url}"></script>`}
        </div>`;
    }
    if (is_wrapper) {
        return `<div id="ahtm-banner-${id_inventory}" style="width: 100%"><script  id="ahtm-script-${id_inventory}" defer src="${script_url}"></script></div>`;
    }
    return `<script id="ahtm-script-${id_inventory}" async src="${script_url}"></script>`;
}


export const formatTokenNumber = (number: any, decimals = 2, unit = '$', compact = true) => {
    // Handle invalid cases
    if (isNaN(number) || number === null || number === undefined) {
        return unit + '0';
    }

    if ((`${number}`)?.includes('e-')) {
        return Number(number).toFixed(decimals).replace(/\.?0+$/, '');
    }

    let formattedNumber: number = Number(number);
    let suffix = '';

    // Convert large numbers to compact form (B, M, K)
    if (compact) {
        if (Math.abs(formattedNumber) >= 1e9) {
            formattedNumber /= 1e9;
            suffix = 'B';
        } else if (Math.abs(formattedNumber) >= 1e6) {
            formattedNumber /= 1e6;
            suffix = 'M';
        } else if (Math.abs(formattedNumber) >= 1e3) {
            formattedNumber /= 1e3;
            suffix = 'K';
        }
    }

    // Convert to string without rounding
    let formattedString = formattedNumber.toString();
    let [integerPart, decimalPart] = formattedString.split('.');

    // Handle decimal part if it exists
    if (decimalPart && decimals > 0) {
        decimalPart = decimalPart.padEnd(decimals, '0').slice(0, decimals);
        formattedString = `${integerPart}.${decimalPart}`;
    } else if (decimals > 0) {
        formattedString = `${integerPart}.${'0'.repeat(decimals)}`;
    } else {
        formattedString = integerPart;
    }

    // Add thousands separator
    const parts = formattedString.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    // Combine and append unit + suffix
    return unit + parts.join('.') + suffix;
};


/**
 * Formats a number or string into a specific format.
 * - For numbers with >=4 zeros after '0.' (e.g., 0.00008464), formats to unit0.0ₙabc.
 * - For other numbers (e.g., 123.45678), takes exactly decimals digits without rounding.
 * @param input - The input number or string (e.g., '123.45678', '1.1458503200866115e-8').
 * @param decimals - Number of decimal digits to keep (default: 2).
 * @param unit - Unit prefix for the output (default: '$').
 * @returns Formatted number with unit.
 */
export const formatScientificNumber = (input: string | number, decimals: number = 6, unit: string = '$'): string => {
    // Validate input
    if (input == null || input === 0 || input === '0' || (typeof input !== 'string' && typeof input !== 'number')) {
        return `${unit}0.${'0'.repeat(decimals)}`;
    }

    // Convert input to a precise number and string
    let num: number;
    let numberStr: string;
    if (typeof input === 'number') {
        if (isNaN(input)) {
            return `${unit}0.${'0'.repeat(decimals)}`;
        }
        num = input;
        numberStr = num.toFixed(20); // High precision to avoid floating-point issues
        numberStr = parseFloat(numberStr).toString(); // Remove trailing zeros
    } else {
        // Remove commas from string input (e.g., "1,000.00" -> "1000.00")
        const cleanedInput = input.replace(/,/g, '');
        if (!/^-?\d*\.?\d*([eE][-+]?[0-9]+)?$/.test(cleanedInput)) {
            return `${unit}0.${'0'.repeat(decimals)}`;
        }
        num = Number(cleanedInput);
        if (isNaN(num)) {
            return `${unit}0.${'0'.repeat(decimals)}`;
        }
        if (cleanedInput.match(/[eE][-+]?[0-9]+/)) {
            numberStr = num.toFixed(20);
            numberStr = parseFloat(numberStr).toString();
        } else {
            numberStr = cleanedInput;
        }
    }

    // Handle scientific notation for very small numbers
    const absNum = Math.abs(num);
    if ((absNum > 0 && absNum < 0.0001) || input.toString().match(/[eE][-+]?[0-9]+/)) {
        // Convert to scientific notation format
        const sciStr = num.toExponential(20).split('e');
        const mantissa = sciStr[0].replace('.', '').replace(/^0+/, '');
        const exponent = parseInt(sciStr[1], 10);
        const isNegative = num < 0;
        if (exponent <= -4) {
            const leadingZeros = Math.abs(exponent) - 1;
            const digitCount = decimals > 4 ? 4 : decimals;
            let digits = mantissa.slice(0, digitCount).padEnd(digitCount, '0');
            // Check if the next digit is >= 9 and round up if necessary
            const nextDigit = mantissa[digitCount] || '0';
            if (Number(nextDigit) >= 9) {
                const roundedNum = Number(`0.${digits}`) + 0.0001; // Increment by 0.0001
                digits = roundedNum.toFixed(4).split('.')[1].slice(0, digitCount).padEnd(digitCount, '0');
            }
            const subscript = String.fromCharCode(8320 + leadingZeros);
            return `${unit}${isNegative ? '-' : ''}0.0${subscript}${digits}`;
        }
    }

    // Split number into integer and decimal parts
    const parts = numberStr.split('.');
    const integerPart = parts[0];
    let decimalPart = parts[1] || '';

    // Handle non-scientific numbers with the specified logic
    if (decimalPart && !input.toString().match(/[eE]/)) {
        const numValue = Number(`${integerPart}.${decimalPart}`);
        const digitAtDecimals = decimalPart[Number(decimals)] || '0';
        numberStr = (numValue > 1 || (decimals >= 4 && Number(digitAtDecimals) >= 9))
            ? numValue.toFixed(decimals)
            : `${integerPart}.${decimalPart.padEnd(decimals, '0').slice(0, decimals)}`;
    } else {
        // No decimal part, pad with zeros
        numberStr = `${integerPart}.${'0'.repeat(decimals)}`;
    }

    // Format integer part with thousands separators
    const formatIntegerPart = (integerStr: string): string => {
        const isNegative = integerStr.startsWith('-');
        const absStr = integerStr.replace(/^-/, '');
        const num = parseInt(absStr, 10);
        if (isNaN(num) || num <= 999) {
            return isNegative ? `-${absStr}` : absStr;
        }
        const formatted = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return isNegative ? `-${formatted}` : formatted;
    };

    // Final formatting
    const finalParts = numberStr.split('.');
    let formattedInteger = formatIntegerPart(finalParts[0]);
    const formattedDecimal = finalParts[1]?.slice(0, decimals).padEnd(decimals, '0') || '0'.repeat(decimals);

    // Remove any existing minus sign from formattedInteger to avoid duplication
    formattedInteger = formattedInteger.replace(/^-/, '');
    const sign = num < 0 && finalParts[0] !== '0' ? '-' : '';

    return `${unit}${sign}${formattedInteger}.${formattedDecimal}`;
};


export const formatScientificToDecimal = (num: number, precision = 20) => {
    const str = String(num);

    if (!/e/i.test(str)) return num;

    const [base, exponent] = str.toLowerCase().split('e');
    const exp = parseInt(exponent, 10);

    let [intPart, fracPart = ''] = base.split('.');
    let number = intPart + fracPart;
    let decimalPos = intPart.length;

    decimalPos += exp;

    if (exp < 0) {
        number = number.padStart(number.length - exp + 1, '0');
        decimalPos = 1;
    } else if (decimalPos > number.length) {
        number = number.padEnd(decimalPos, '0');
    }

    const result = number.slice(0, decimalPos) + '.' + number.slice(decimalPos);
    const result_format = result.replace(/^0+(?=\d)|\.?0+$/g, '');
    return Number(result_format);
}

export const formatStringDotDotDot = (str: string = '', start: number = 5, end: number = 4) => {
    return (`${str}`)?.slice(0, start) + "..." + (`${str}`)?.slice(-end)
};

export const formatTimeToAgo = (time: any, t: any, isFullTime: boolean = false, typeFormat: string = 'YYYY-MM-DD HH:mm:ss', lang: 'en' | 'ko' | string = 'en') => {
    const moment = require('moment-timezone');
    if (lang === 'ko') {
        require('moment/locale/ko');
        moment.locale('ko');
    } else {
        moment.locale('en');
    }

    const localTime = moment.unix(time).tz(moment.tz.guess());
    // const date = new Date(localTime);
    // const now = new Date();
    // const diff = now.getTime() - date.getTime();
    // const minutes = Math.floor(diff / 1000 / 60);
    // const hours = Math.floor(diff / 1000 / 60 / 60);
    // const days = Math.floor(diff / 1000 / 60 / 60 / 24);

    // if (isFullTime) {
    //     return moment(date).tz(moment.tz.guess()).format(typeFormat);
    // }
    // if (Math.floor(diff / 1000) < 10) {
    //     return `${Math.floor(diff / 1000)}${t("s ago")}`;
    // }
    return moment(localTime).tz(moment.tz.guess()).format(typeFormat);

};

export const customToFixed = (num: string | number = 0, decimalPlaces: string | number = 0) => {
    if (typeof num !== 'number') {
        return num;
    }

    const factor = Math.pow(10, Number(decimalPlaces || 0));
    const rounded = Math.round(num * factor) / factor;

    return rounded.toString();
};

export const toFixedTrunc = (num: number | string, digits: number | string = 0) => {
    const parts = String(num).split(".");
    if (parts.length === 1 || Number(digits) === 0) {
        return parts[0];
    }
    return parts[0] + "." + parts[1].substring(0, Number(digits)).padEnd(Number(digits), "0");
}